import { useState, useEffect } from "react";
import Button from '../../../components/button/button';
import Input from '../../../components/input/input';
import Label from '../../../components/label/label';
import { useSettings } from '../../../hooks/useSettings';

function Personals() {
    const [show, setShow] = useState(true);
    const [edit, setEdit] = useState(false);
    const [prename, setPrename] = useState('');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [postCode, setPostCode] = useState('');
    const [town, setTown] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [partners, setPartners] = useState([]);

    const { fetchData, data, savePersonalData } = useSettings();

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleEdit = () => {
        setEdit(true);
        setShow(false);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setEdit(false);
        setShow(true);
    }

    const addPartner = () => {
        setPartners([...partners, { prename: '', name: '' }]);
    };

    const handlePartnerChange = (index, field, value) => {
        const updated = partners.map((p, i) => i === index ? { ...p, [field]: value } : p);
        setPartners(updated);
    };

    const removePartner = (index) => {
        setPartners(partners.filter((_, i) => i !== index));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const personalDataChange = { name, prename, partners, address, postCode, town, phoneNumber };
        savePersonalData(e, personalDataChange);
    };

    useEffect(() => {
        if (edit) {
            setName(data.name || '');
            setPrename(data.prename || '');
            setAddress(data.address || '');
            setPostCode(data.postCode || '');
            setTown(data.town || '');
            setPhoneNumber(data.phoneNumber || '');
            setPartners(data.partners || []);
        }
    }, [edit, data]);

    return (
        <div>
            {show && (
                <>
                    <p>Vorname: {data.prename}</p>
                    <p>Nachname: {data.name}</p>
                    <p>Adresse: {data.address ? data.address : 'Noch nicht angegeben'}</p>
                    <p>PLZ: {data.postCode ? data.postCode : 'Noch nicht angegeben'}</p>
                    <p>Stadt: {data.town ? data.town : 'Noch nicht angegeben'}</p>
                    <p>Email: {data.email}</p>
                    <p>Telefon: {data.phoneNumber ? data.phoneNumber : 'Noch nicht angegeben'}</p>
                    
                    {/* Partner Anzeige */}
                    {data.partners && data.partners.length > 0 && (
                        <div>
                            <p>Partner:</p>
                            {data.partners.map((p, i) => (
                                <p key={i}>- {p.prename} {p.name}</p>
                            ))}
                        </div>
                    )}
                    
                    <Button buttonValue='Bearbeiten' onClick={handleEdit} />
                </>
            )}

            {edit && (
                <form onSubmit={handleSubmit} className="settingsForm">
                    <Label labelFor='prename' labelValue='Vorname: ' />
                    <Input inputId='prename' inputName='prename' inputType='text' borderColor="black" inputValue={prename} onChange={(e) => setPrename(e.target.value)} /><br />
                    <Label labelFor='name' labelValue='Nachname: ' />
                    <Input inputId='name' inputName='name' inputType='text' borderColor="black" inputValue={name} onChange={(e) => setName(e.target.value)} /><br />
                    <Label labelFor='address' labelValue='Adresse: ' />
                    <Input inputId='address' inputName='address' inputType='text' borderColor="black" inputValue={address} onChange={(e) => setAddress(e.target.value)} /><br />
                    <Label labelFor='postCode' labelValue='PLZ: ' />
                    <Input inputId='postCode' inputName='postCode' inputType='text' borderColor="black" inputValue={postCode} onChange={(e) => setPostCode(e.target.value)} /><br />
                    <Label labelFor='town' labelValue='Stadt: ' />
                    <Input inputId='town' inputName='town' inputType='text' borderColor="black" inputValue={town} onChange={(e) => setTown(e.target.value)} /><br />
                    <Label labelFor='phoneNumber' labelValue='Telefon: ' />
                    <Input inputId='phoneNumber' inputName='phoneNumber' inputType='text' borderColor="black" inputValue={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} /><br />
                    {/* Partner Edit-Sektion */}
                    <div style={{ margin: '20px 0', padding: '10px', border: '1px solid #ccc' }}>
                        <h4>Partner</h4>
                        {partners.map((partner, index) => (
                            <div key={index} style={{ marginBottom: '10px', borderBottom: '1px dotted #ccc' }}>
                                <Input 
                                    placeholder="Vorname" 
                                    inputValue={partner.prename} 
                                    onChange={(e) => handlePartnerChange(index, 'prename', e.target.value)} 
                                />
                                <Input 
                                    placeholder="Nachname" 
                                    inputValue={partner.name} 
                                    onChange={(e) => handlePartnerChange(index, 'name', e.target.value)} 
                                />
                                <button type="button" onClick={() => removePartner(index)} style={{color: 'red'}}>Löschen</button>
                            </div>
                        ))}
                        <Button buttonType="button" onClick={addPartner} buttonValue="+ Partner hinzufügen" />
                    </div>
                    
                    <Button buttonType='button' buttonValue='Abbrechen' onClick={handleCancel} />
                    <Button buttonType='submit' buttonValue='Speichern' />
                </form>
            )}
        </div>
    );
}

export default Personals;